import Advertiser from '@/common/models/advertisers/Advertiser';

export interface ITTDCampaignAPI {
  ttd_advertiser_currency: string;
  ttd_advertiser_id: string;
  ttd_advertiser_name: string;
  is_published?: boolean;
  planttdcampaign_id?: number;
  published_data: ITTDPublishedData;
}

export interface ITTDPublishedData {
  ttd_adgroups?: ITTDAdgroup[];
  ttd_campaign?: ITTDPublishedDataCampaign;
  ttd_bidlists?: ITTDBidList[];
}

export interface ITTDAdgroup {
  ttd_adgroup_id: string;
  ttd_adgroup_name: string;
}

export interface ITTDPublishedDataCampaign {
  ttd_campaign_id: string;
  ttd_campaign_name: string;
}

export interface ITTDBidList {
  plan_id: number;
  ttd_bidlist_id: string;
  ttd_bidlist_name: string;
}

export default class TTDCampaign {
  advertiserID: string;
  advertiserName: string;
  advertiserCurrency: string;
  isPublished?: boolean;
  planTTDCampaignId?: string;
  planTTDTargetLists?: ITTDBidList[];

  constructor(
    advertiserID: string = null,
    advertiserName: string = null,
    advertiserCurrency: string = null,
    isPublished: boolean = false,
    planTTDCampaignId: string = '',
    planTTDTargetLists: ITTDBidList[] = [],
  ) {
    this.advertiserID = advertiserID;
    this.advertiserName = advertiserName;
    this.advertiserCurrency = advertiserCurrency;
    this.isPublished = isPublished;
    this.planTTDCampaignId = planTTDCampaignId;
    this.planTTDTargetLists = planTTDTargetLists;
  }

  static fromObjectAdvertiser(obj: Advertiser): TTDCampaign {
    return new TTDCampaign(obj.id as string, obj.name, obj.currency);
  }

  static fromApi(apiObject: ITTDCampaignAPI): TTDCampaign {
    return new TTDCampaign(
      apiObject.ttd_advertiser_id,
      apiObject.ttd_advertiser_name,
      apiObject.ttd_advertiser_currency,
      apiObject.is_published,
      apiObject.published_data?.ttd_campaign?.ttd_campaign_id,
      apiObject.published_data?.ttd_bidlists,
    );
  }

  static toAdvertiserApi(obj: Advertiser | TTDCampaign) {
    let apiObject = {} as TTDCampaign;
    if (obj instanceof Advertiser) {
      apiObject = new TTDCampaign(obj.id as string, obj.name, obj.currency);
    } else {
      apiObject = obj as TTDCampaign;
    }
    return {
      ttd_advertiser_id: apiObject.advertiserID,
      ttd_advertiser_name: apiObject.advertiserName,
      ttd_advertiser_currency: apiObject.advertiserCurrency,
    };
  }
}
